import React from 'react'
import { useRouter } from 'next/router'
import { Box, Button, Card, Flex, Text } from 'pcln-design-system'
import SleepIcon from './SleepIcon'
import { defaultToday, defaultTomorrow } from '../../utils/date-helper'
import analytics from '../../utils/analytics'
import useGeoPosition from '../CustomHooks/useGeoPosition'
import { invokeFetchCurrentCityData } from '../../machines/currentLocationMachine'

export default function HotelsTonight() {
  const { pathname = '/' } = useRouter()
  const category = pathname === '/hotels' ? 'HOTEL_HOME' : 'PCLN_HOME'

  const { latitude, longitude } = useGeoPosition()
  const position = {
    coords: {
      latitude,
      longitude
    }
  }

  const relaxListingsCallBack = () => {
    invokeFetchCurrentCityData({ position })
      .then(data => {
        window.location.href =
          data && data.lat && data.lon && data.itemName
            ? `/relax/geo/${data.itemName}/${data.lat}/${data.lon}/from/${defaultToday}/to/${defaultTomorrow}/rooms/1`
            : '/hotels'
      })
      .catch(err => {
        analytics.fireEvent({
          event: 'Error',
          category,
          action: 'Click',
          data: err
        })
        window.location.href = '/hotels'
      })
  }

  const handleHotelsTonightClick = (event: MouseEvent) => {
    event.preventDefault()

    analytics.fireEvent({
      category,
      action: 'Click',
      label: 'Hotel Tonight'
    })

    relaxListingsCallBack()
  }

  return (
    <Box>
      <Button
        width={1}
        variation="link"
        data-testid="HOMEPAGE_MWEB_TONIGHT_ONLY_SEARCH"
        onClick={(event: MouseEvent) => handleHotelsTonightClick(event)}
        target="_self"
      >
        <Card color="background.lightest" boxShadowSize="sm" br="2px">
          <Flex px={2}>
            <Box pr={2} mt={2}>
              <SleepIcon
                color="#004499"
                height={40}
                translateX={-2}
                translateY={-1}
                viewBoxHeight={20}
                viewBoxWidth={20}
                width={36}
              />
            </Box>
            <Box p={2}>
              <Text
                fontWeight="bold"
                color="black"
                fontSize={2}
                textAlign="left"
              >
                Need a hotel tonight?
              </Text>
              <Text color="text" mt={2} fontSize={0} textAlign="left">
                Find deals near you.
              </Text>
            </Box>
            <Box width="70px" ml="auto" my="auto">
              <Button size="small" width={1}>
                Search
              </Button>
            </Box>
          </Flex>
        </Card>
      </Button>
    </Box>
  )
}
